import AcheckboxGroup from '@/components/AcheckboxGroup';
import AcolorPicker from '@/components/AcolorPicker';
import Aeditor from '@/components/Aeditor';
import AiconSelect from '@/components/AiconSelect';
import AnumberRange from '@/components/AnumberRange';
import Aselect from '@/components/Aselect';
import Aswitch from '@/components/Aswitch';
import AtreeSelect from '@/components/AtreeSelect';
import Aupload from '@/components/Aupload';
import AuploadIcon from '@/components/Aupload/Icon';
import moment from 'moment';
import './index.css';

export default {
  name: 'AformItem',
  props: {
    form: { type: Object, default: () => ({}) },
    data: { type: Array, default: () => [] },
  },
  data() {
    const { ...a } = this.$attrs;
    return {
      field: a.dataIndex || a.field || a.index || a.prop || a.name || a.key || null,
      checked: false,
      pickerOptions: {
        date: {
          shortcuts: [
            { text: '今天', onClick: a => a.$emit('pick', moment().toDate()) },
            { text: '昨天', onClick: a => a.$emit('pick', moment().subtract(1, 'days').toDate()) },
            { text: '上周', onClick: a => a.$emit('pick', moment().subtract(1, 'weeks').toDate()) },
            { text: '上月', onClick: a => a.$emit('pick', moment().subtract(1, 'months').toDate()) },
            { text: '上季', onClick: a => a.$emit('pick', moment().subtract(1, 'quarter').toDate()) },
            { text: '去年', onClick: a => a.$emit('pick', moment().subtract(1, 'years').toDate()) },
            { text: '前年', onClick: a => a.$emit('pick', moment().subtract(2, 'years').toDate()) },
            { text: '清空', onClick: a => a.$emit('pick', undefined) },
          ]
        },
        daterange: {
          shortcuts: [
            { text: '昨天', onClick: a => a.$emit('pick', [moment().subtract(1, 'days').toDate(), new Date()]) },
            { text: '本周', onClick: a => a.$emit('pick', [moment().startOf('weeks').toDate(), new Date()]) },
            { text: '上周', onClick: a => a.$emit('pick', [moment().subtract(1, 'weeks').toDate(), new Date()]) },
            { text: '本月', onClick: a => a.$emit('pick', [moment().startOf('months').toDate(), new Date()]) },
            { text: '上月', onClick: a => a.$emit('pick', [moment().subtract(1, 'months').toDate(), new Date()]) },
            { text: '本季', onClick: a => a.$emit('pick', [moment().startOf('quarter').toDate(), new Date()]) },
            { text: '上季', onClick: a => a.$emit('pick', [moment().subtract(1, 'quarter').toDate(), new Date()]) },
            { text: '今年', onClick: a => a.$emit('pick', [moment().startOf('years').toDate(), new Date()]) },
            { text: '去年', onClick: a => a.$emit('pick', [moment().subtract(1, 'years').toDate(), new Date()]) },
            { text: '清空', onClick: a => a.$emit('pick', undefined) },
          ]
        },
        time: {},
        year: {
          shortcuts: [
            { text: '今年', onClick: a => a.$emit('pick', moment().toDate()) },
            { text: '去年', onClick: a => a.$emit('pick', moment().subtract(1, 'years').toDate()) },
            { text: '前年', onClick: a => a.$emit('pick', moment().subtract(2, 'years').toDate()) },
            { text: '三年前', onClick: a => a.$emit('pick', moment().subtract(3, 'years').toDate()) },
            { text: '四年前', onClick: a => a.$emit('pick', moment().subtract(4, 'years').toDate()) },
            { text: '五年前', onClick: a => a.$emit('pick', moment().subtract(5, 'years').toDate()) },
            { text: '六年前', onClick: a => a.$emit('pick', moment().subtract(6, 'years').toDate()) },
            { text: '七年前', onClick: a => a.$emit('pick', moment().subtract(7, 'years').toDate()) },
            { text: '清空', onClick: a => a.$emit('pick', undefined) },
          ]
        },
        month: {
        },
      },
    }
  },
  computed: {
    smart() {
      const a = this.$attrs;
      const smart = (a.shortcuts || a.shortcut || a.quickly || a.quick || a.smart || a.fast || a.all);
      return smart !== undefined ? smart : true;
    },
    format() {
      const { ...r } = this.$attrs;
      if (r.render) return (r.render(this.$attrs));
      const on = { input: (a) => this.$emit('input', a), ...r, change: (a) => this.change(a) };
      const style = { ...r.style };
      const label = r.text || r.label || r.title || '';
      const limit = parseInt((r.maxlength || r.length || r.max || r.maxLength) + 1) || null;
      const attrs = { smart: this.smart, clearable: true, filterable: true, collapseTags: true, ...r };
      const values = (a = {}) => (typeof a === 'string') ? a : (`${(a.value || a.code || a.val || a.id)}`);
      const labels = (a = {}) => (typeof a === 'string') ? a : (a.label || a.title || a.text || a.name || a.key);
      const type = (r.type && (r.type != '')) ? r.type.toLowerCase().trim() : '';
      const { field, form = {}, data = [] } = this;
      if ((type === 'range') || (type === 'scope') || (type === 'between')) return (<AnumberRange v-model={form[field]} style={style} {...{ on }} {...{ attrs }} />);
      if ((type === 'year') || (type === 'years')) return (<el-date-picker type={r.type} v-model={form[field]} align="center" value-format="yyyy" placeholder={`请选择${label}`} picker-options={this.pickerOptions.year} style={style} {...{ on }} {...{ attrs }} />);
      if ((type === 'month') || (type === 'months')) return (<el-date-picker type={r.type} v-model={form[field]} align="center" value-format="yyyy-MM" placeholder={`请选择${label}`} picker-options={this.pickerOptions.month} style={style} {...{ on }} {...{ attrs }} />);
      if ((type === 'mail') || (type === 'email')) return (<el-input v-model={form[field]} placeholder={`请输入${label}`} style={{ maxWidth: '320px', ...style }} {...{ on }} {...{ attrs }} />);
      if ((type === 'image') || (type === 'images')) return (<AuploadIcon v-model={form[field]} src={form[field]} placeholder={`请选择${label}`} style={style} {...{ on }} {...{ attrs }} />);
      if ((type === 'tree') || (type === 'treeselect') || (type === 'selecttree')) return (<AtreeSelect v-model={form[field]} placeholder={`请选择${label}`} data={data} style={style} {...{ on }} {...{ attrs }} />);
      if ((type === 'icon') || (type === 'iconselect') || (type === 'selecticon')) return (<AiconSelect v-model={form[field]} placeholder={`请选择${label}`} data={data} style={style} {...{ on }} {...{ attrs }} />);
      if ((type === 'theme') || (type === 'color') || (type === 'colour')) return (<AcolorPicker v-model={form[field]} placeholder={`请选择${label}`} style={style} {...{ on }} {...{ attrs }} />);
      if ((type === 'tel') || (type === 'phone') || (type === 'telephone')) return (<el-input v-model={form[field]} placeholder={`请输入${label}`} style={{ maxWidth: '200px', ...style }} {...{ on }} {...{ attrs }} />);
      if ((type === 'editor') || (type === 'article') || (type === 'context')) return (<Aeditor v-model={form[field]} placeholder={`请输入${label}`} style={style} {...{ on }} {...{ attrs }} />);
      switch (type) {
        case 'textarea': return (<el-input v-model={form[field]} maxlength={limit} rows="5" resize="none" placeholder={`请输入${label}`} style={style} {...{ on }} {...{ attrs }} />);
        case 'password': return (<el-input v-model={form[field]} maxlength={limit} placeholder={`请输入${label}`} show-password style={style} {...{ on }} {...{ attrs }} />);
        case 'number': return (<el-input-number v-model={form[field]} min={0} max={10000000000} controls={false} controls-position="right" placeholder={`请输入${label}`} style={{ width: '140px', ...style }} {...{ on }} {...{ attrs }} />);
        case 'select': return (<Aselect v-model={form[field]} placeholder={`请选择${label}`} data={data} style={style} {...{ on }} {...{ attrs }} />);
        case 'cascader': return (<el-cascader v-model={form[field]} options={data} placeholder={`请选择${label}`} class="a-form-item-cascader" style={style} props={{ props: { multiple: false, checkStrictly: true, emitPath: true } }} {...{ on }} {...{ attrs }} />);
        case 'checkbox': return (<el-checkbox v-model={form[field]} true-label="true" false-label="false" style={style} {...{ on }} {...{ attrs }}>{label}</el-checkbox>);
        case 'checkboxgroup': return (<AcheckboxGroup v-model={form[field]} placeholder={`请选择${label}`} data={data} style={style} {...{ on }} {...{ attrs }} />);
        case 'radio': return data && data.length > 0 && (
          <el-radio-group v-model={form[field]} style={style} {...{ on }} {...{ attrs }}>
            {data.map((a, b) => <el-radio key={b} label={values(a)}>{labels(a)}</el-radio>)}
          </el-radio-group>
        );
        case 'switch': return (<Aswitch v-model={form[field]} active-value="1" inactive-value="0" active-text="启用" inactive-text="禁用" active-color={null} style={style} {...{ on }} {...{ attrs }} />);
        case 'datetimerange': return (<el-date-picker type={r.type} v-model={form[field]} align="center" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder={`请选择${label}`} start-placeholder="开始时间" end-placeholder="结束时间" picker-options={this.pickerOptions.daterange} style={style} {...{ on }} {...{ attrs }} />);
        case 'daterange': return (<el-date-picker type={r.type} v-model={form[field]} align="center" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" placeholder={`请选择${label}`} start-placeholder="开始时间" end-placeholder="结束时间" picker-options={this.pickerOptions.daterange} style={style} {...{ on }} {...{ attrs }} />);
        case 'datetime': return (<el-date-picker type={r.type} v-model={form[field]} align="center" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder={`请选择${label}`} picker-options={this.pickerOptions.date} style={style} {...{ on }} {...{ attrs }} />);
        case 'date': return (<el-date-picker type={r.type} v-model={form[field]} align="center" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" placeholder={`请选择${label}`} picker-options={this.pickerOptions.date} style={style} {...{ on }} {...{ attrs }} />);
        case 'time': return (<el-time-picker type={r.type} v-model={form[field]} align="center" value-format="HH:mm:ss" placeholder={`请选择${label}`} picker-options={this.pickerOptions.time} style={style} {...{ on }} {...{ attrs }} />);
        case 'upload': return (<Aupload v-model={form[field]} placeholder={`请选择${label}`} style={style} {...{ on }} {...{ attrs }} />);
        default: return (<el-input v-model={form[field]} maxlength={limit} placeholder={`请输入${label}`} style={style} {...{ on }} {...{ attrs }} />);
      }
    },
  },
  methods: {
    change(checked = []) {
      this.$emit('change', checked, this.filter(checked));
      this.$attrs.change && (this.$attrs.change(checked, this.filter(checked)));
    },
    filter(value = '') {
      if (value && value !== '') {
        let data = {};
        this.data.forEach(a => {
          const index = (`${a.values || a.value || a.code || a.val || a.id || a}`);
          if (value === index) data = a;
        });
        return data;
      }
    },
  },
  render() {
    return this.format;
  }
}